<cm-sidebar-layout>
    <cm-tabs cm-tabs [tabs]="$tabs()" (onChangeTab)="onChangeTabEvent($event)" [activeTab]="$selectedTab()"></cm-tabs>
    <cm-item-filters cm-filters>
        @if ($selectedTab() === "projects") {
            <cm-project-tree [currentProjectId]="$projectId()" [currentSetId]="$setId()" [organization]="$organization() ?? undefined"></cm-project-tree>
        }
        @if ($selectedTab() === "filters") {
            <cm-tag-search-filter
                title="Search"
                [selectableTagTypes]="[Enums.TagType.PictureAnnotation]"
                [showOrganizationGroupFilter]="false"
            ></cm-tag-search-filter>
            @if ($can().read.organization()) {
                <cm-pinned-filter label="Pinned">
                    <cm-pinned-filter-option [indicateActivated]="false" [queryParams]="{tab: 'filters', organizationId: ''}"
                        >Clear filters</cm-pinned-filter-option
                    >
                    <cm-pinned-filter-option
                        [queryParams]="{
                            tab: 'filters',
                            pictureState: Enums.InPipelineStates.Picture,
                            nextActor: Enums.NextActors.ProductionInProgress,
                        }"
                    >
                        In progress
                    </cm-pinned-filter-option>
                    <cm-pinned-filter-option
                        [queryParams]="{
                            tab: 'filters',
                            pictureState: Enums.InPipelineStates.Picture,
                            nextActor: Enums.NextActors.ProductionWaitingForFeedback,
                        }"
                    >
                        Waiting for feedback
                    </cm-pinned-filter-option>
                </cm-pinned-filter>
            } @else {
                <cm-pinned-filter label="Pinned">
                    <cm-pinned-filter-option [indicateActivated]="false" [queryParams]="{tab: 'filters', organizationId: $organization()?.id}"
                        >Clear filters
                    </cm-pinned-filter-option>
                    <cm-pinned-filter-option [queryParams]="{tab: 'filters', pictureState: Enums.PictureState.Draft, organizationId: $organization()?.id}">
                        Draft
                    </cm-pinned-filter-option>
                    <cm-pinned-filter-option
                        [queryParams]="{
                            tab: 'filters',
                            pictureState: Enums.InPipelineStates.Picture,
                            nextActor: Enums.NextActors.CustomerInProgress,
                            organizationId: $organization()?.id,
                        }"
                        >In progress
                    </cm-pinned-filter-option>
                    <cm-pinned-filter-option
                        [queryParams]="{
                            tab: 'filters',
                            pictureState: Enums.InPipelineStates.Picture,
                            nextActor: Enums.NextActor.Customer,
                            organizationId: $organization()?.id,
                        }"
                        >Waiting for feedback
                    </cm-pinned-filter-option>
                    <cm-pinned-filter-option [queryParams]="{tab: 'filters', pictureState: Enums.PictureState.OnHold, organizationId: $organization()?.id}"
                        >On hold
                    </cm-pinned-filter-option>
                    <cm-pinned-filter-option [queryParams]="{tab: 'filters', pictureState: Enums.PictureState.Completed, organizationId: $organization()?.id}">
                        Completed
                    </cm-pinned-filter-option>
                </cm-pinned-filter>
            }
            <cm-checkboxes-filter label="Up Next" name="nextActor" [options]="Labels.NextActor"></cm-checkboxes-filter>
            @if ($can().read.filters("additional")) {
                <cm-checkboxes-filter label="Availability" name="hasAssignedUser" [options]="Labels.Assigned"></cm-checkboxes-filter>
                <cm-checkboxes-filter label="Assets" name="assetsCompleted" [options]="Labels.Completed"></cm-checkboxes-filter>
            }
            <cm-checkboxes-filter label="State" name="pictureState" [options]="Labels.PictureState"></cm-checkboxes-filter>
            @if ($can().read.filters("additional")) {
                <cm-checkboxes-filter label="User" name="userId" [options]="$visibleUsers()"></cm-checkboxes-filter>
                <cm-checkboxes-filter label="Payment State" name="paymentState" [options]="Labels.PaymentState"></cm-checkboxes-filter>
            }
        }
    </cm-item-filters>
    <cm-pictures-grid [selectedTab]="$selectedTab()"></cm-pictures-grid>
</cm-sidebar-layout>
<router-outlet></router-outlet>
